export const FETCH_CONTESTANT = "FETCH_CONTESTANT";
export const FETCH_CONTESTANTS = "FETCH_CONTESTANTS";
export const VOTE_CONTESTANT = "VOTE_CONTESTANT";
export const CONTESTANT_VOTES_PAYMENT = "CONTESTANT_VOTES_PAYMENT";
export const OTP_VERIFICATION = "OTP_VERIFICATION";
export const PAYMENT_VERIFICATION = "PAYMENT_VERIFICATION";
